
<template>
  <div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <h3 class="text-center">Please use the filter to find the history of your exchange rates</h3>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  export default {
    name: 'ExchangeRateHistory',
    mixins: [AdminEntityMixin, HelperMixin],
    data () {
      return {
        transformForUpdate: {},
        editEntityScreen: 'Admin - Edit/View Exchange Rate History',
        newEntityScreen: 'Admin - Exchange Rate Histories',
        boxes: [],
        entity: {},
        entityName: 'exchange-rate-history'
      }
    },
    computed: {
      isValid () {
        return false
      }
    },
    methods: {
      getBaseData () {
        return {}
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/ExchangeRateHistory/ExchangeRateHistory.vue